import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { Label } from 'src/app/interfaces/label';

@Component({
  selector: 'app-tree-label',
  templateUrl: './tree-label.component.html',
  styleUrls: ['./tree-label.component.scss'],
})
export class TreeLabelComponent implements OnInit {

  @Input() level: number = 0;
  @Input() label?: Label;

  @Output() onSelected: EventEmitter<Label> = new EventEmitter<Label>();

  constructor() { }

  ngOnInit() { }

  selectLabel() {
    this.onSelected.emit(this.label);
  }

}
